import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, shareReplay } from "rxjs";
import { CategorieGralResponse } from "../interface/caregorie-gral.interface";
import { environment } from "../../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})


export class CategoriesGralService {

  private readonly apiUrl = environment.apiUrl
  constructor(private http: HttpClient) {

  }

  loadCategoriesGral(): Observable<CategorieGralResponse> {
    return this.http.get<CategorieGralResponse>(`${this.apiUrl}/establishment/categoriesGral`).pipe(
      shareReplay({
        bufferSize: 1,
        refCount: true
      })
    );
  }

}
